var map = {
	"./Splash.svg": 8358,
	"./Sprinkle.svg": 9104,
	"./backEndIcon.png": 6788,
	"./bgSVG.svg": 6579,
	"./circleCutoutLogo.png": 9043,
	"./coddingLottie": 2299,
	"./coddingLottie.json": 2299,
	"./code-svgrepo-com.svg": 604,
	"./coloredInitalsFavicon.png": 7340,
	"./coloredInitialsLogo.png": 2390,
	"./coloredInitialsLogo_old.png": 2762,
	"./database-svgrepo-com.svg": 7876,
	"./databaseIcon.png": 1574,
	"./diagramSvg.svg": 3900,
	"./expand-icon-white - Copy.png": 5285,
	"./expand-icon-white.png": 66,
	"./expand-icon.png": 3723,
	"./frontEndIcon.png": 7135,
	"./gradientBg.jpg": 3368,
	"./logoEllore.png": 9911,
	"./logoFrame.png": 9164,
	"./logoRecipeBox.png": 5819,
	"./newLogoBlack.png": 7250,
	"./newLogoColored.png": 7749,
	"./newLogoPurple.png": 3046,
	"./orangeCircleCutoutLogo.png": 3709,
	"./otmFullFormLogo.png": 9614,
	"./patternAnimatedBg": 1779,
	"./patternAnimatedBg.json": 1779,
	"./polyWebLogoBase.png": 311,
	"./prjoectLogoBase.png": 9805,
	"./rocket": 1768,
	"./rocket.json": 1768,
	"./smallLogo_colored.png": 4981,
	"./spotifactsLogo.png": 1700,
	"./stringWaves": 6418,
	"./stringWaves.json": 6418,
	"./svgBackground": 7571,
	"./svgBackground.js": 7571,
	"./svgMugLogoRed.svg": 5890,
	"./svgMugRedTemp.svg": 2532,
	"./svgNetwork.svg": 7659,
	"./svgSplash": 6122,
	"./svgSplash.js": 6122,
	"./svgTiles.svg": 1149,
	"./terminal": 5542,
	"./terminal.json": 5542,
	"./terminalWhite": 3601,
	"./terminalWhite.json": 3601,
	"./toolsIcon.png": 7649,
	"./website-svgrepo-com.svg": 8622,
	"./welcome-splash": 7212,
	"./welcome-splash.json": 7212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;